var $ = require('../internals/export');
var setPrototypeOf = require('../internals/object-set-prototype-of');

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/modules/es.object.set-prototype-of.js
// module id = r8F0
// module chunks = 0